module.exports = __webpack_public_path__ + "img/S140.ef044471.jpg";